import service from './treeService'
import _ from 'lodash'
import {StateChanges} from '../store/stateChanges'
import store from '../store'

let $counter = 0

export class Text {
  constructor (keys, name) {
    this.keys = keys
    this.name = name
    this.description = keys ? summarizeKeys(keys) : null
    this.id = $counter++
    this.setDisplayName()
  }

  // this cannot be a getter because Vue wouldn't make it reactive
  setDisplayName () {
    this.displayName = this.name || this.description
  }

  setNameInternal (name) {
    this.name = name
    this.setDisplayName()
  }

  // changing the name is handled inside a mutation because this text might be in the store
  setName (name) {
    store.commit(StateChanges.SET_TEXT_NAME, {text: this, name})
  }

  isFavorite () {
    return store.state.favorites.some(favorite =>
      ((!favorite.text.name && !this.name) || favorite.text.name === this.name) &&
      _.isEqual(favorite.text.keys, this.keys))
  }

  hasKeys () {
    return this.keys && this.keys.length > 0
  }
}

export function summarizeKeys (keys) {
  function bookChapterAndVerse (key) {
    let matches = /\/Tanakh\/[^/]*\/([^/]*)?(?:\/Chapter ([^/]*))?(?:\/Pasuk (.*))?/.exec(key)
    if (!matches) {
      return _.drop(/Tanakh\/([^/]*)/.exec(key))
    }
    matches.shift()
    return _.compact(matches)
  }

  if (!keys || keys.length === 0) {
    return 'No text selected.'
  }
  if (keys.mode === 'BrowseThisComputer') {
    return 'Uploaded Text'
  }
  const sortedKeys = keys.length > 1 ? service.treeSort(keys) : keys
  if (keys.some(key => !key.startsWith('/Dicta Corpus/Tanakh'))) {
    return keys.map(key => key.replace('/Dicta Corpus/', '')).join(', ')
  }
  let summaries = []
  let lastSummary
  let lastRangeStart
  let lastParts = []
  sortedKeys.forEach(key => {
    const parts = bookChapterAndVerse(key)
    let match = false
    let range = false
    if (parts.length === lastParts.length) {
      match = true
      for (let i = 0; i < parts.length - 1; i++) {
        if (parts[i] !== lastParts[i]) {
          match = false
        }
      }
      if (+parts[parts.length - 1] === (+lastParts[parts.length - 1] + 1)) {
        range = true
      }
    }
    lastParts = parts
    if (match && parts.length > 1) {
      if (range) {
        lastSummary = parts[0]
        if (parts[1]) {
          lastSummary += ' ' + (parts.length === 2 ? lastRangeStart + '-' : '') + parts[1]
        }
        if (parts[2]) {
          lastSummary += ':' + lastRangeStart + '-' + parts[2]
        }
        summaries[summaries.length - 1] = lastSummary
      } else {
        lastRangeStart = parts[parts.length - 1]
        summaries.push(parts[parts.length - 1])
      }
    } else {
      lastSummary = parts[0]
      if (parts[1]) {
        lastSummary += ' ' + parts[1]
      }
      if (parts[2]) {
        lastSummary += ':' + parts[2]
      }
      lastRangeStart = parts[parts.length - 1]
      summaries.push(lastSummary)
    }
  })
  return summaries.join(', ')
}



// WEBPACK FOOTER //
// ./src/texts/index.js